module.exports = __webpack_public_path__ + "img/228.kitchen_cleanliness.9eb55ac5.svg";